export interface Route {
  name: string;
  href: string;
  image: string;
  active_image?: string;
}

export const routes: Route[] = [
  {
    name: "Информация",
    href: "/info",
    image: "/info.svg",
    active_image: "/info_active.svg",
  },
  {
    name: "Главная",
    href: "/",
    image: "/home.svg",
    active_image: "/home_active.svg",
  },
  {
    name: "Кабинет",
    href: "/cabinet",
    image: "/lk.svg",
    active_image: "/login_active.svg",
  },
];
